import * as React from "react"

const SvgInlineSnippet = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 20V6q0-.824.587-1.412A1.93 1.93 0 0 1 5 4h4.2a3 3 0 0 1 1.088-1.45A2.86 2.86 0 0 1 12 2q.95 0 1.713.55.762.55 1.087 1.45H19q.824 0 1.413.588Q21 5.175 21 6v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 22zm0-2h14V6H5zm3-2h5a.97.97 0 0 0 .713-.288A.97.97 0 0 0 14 17a.97.97 0 0 0-.287-.712A.97.97 0 0 0 13 16H8a.97.97 0 0 0-.713.288A.97.97 0 0 0 7 17q0 .424.287.712Q7.575 18 8 18m0-4h8a.97.97 0 0 0 .712-.287A.97.97 0 0 0 17 13a.97.97 0 0 0-.288-.713A.97.97 0 0 0 16 12H8a.97.97 0 0 0-.713.287A.97.97 0 0 0 7 13q0 .424.287.713Q7.575 14 8 14m0-4h8a.97.97 0 0 0 .712-.287A.97.97 0 0 0 17 9a.97.97 0 0 0-.288-.712A.97.97 0 0 0 16 8H8a.97.97 0 0 0-.713.288A.97.97 0 0 0 7 9q0 .424.287.713Q7.575 10 8 10m4-4.75a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75" />
  </svg>
)
export default SvgInlineSnippet
